import { HeartHandshake, Users, Trees, Home } from "lucide-react";

const POINTS = [
  {
    icon: HeartHandshake,
    title: "One familiar face",
    copy: "Every booking is personally cared for by Carly, from introductions to ongoing walks and overnight stays.",
  },
  {
    icon: Users,
    title: "Considered group matching",
    copy: "Dogs are introduced and grouped with attention to temperament, energy and compatibility.",
  },
  {
    icon: Trees,
    title: "Space to enjoy",
    copy: "Mary's Meadow and other carefully chosen locations provide varied outdoor experiences suited to the dogs in each group.",
  },
  {
    icon: Home,
    title: "Care beyond the walk",
    copy: "Home visits and in-home sitting mean you can rely on one familiar person for more of your pet-care needs.",
  },
];

export const Details = () => (
  <section className="py-16 sm:py-24 lg:py-32" data-testid="details-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">The difference</p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium text-[#292A26] tracking-tight leading-tight mt-4" data-testid="details-heading">
            The details matter.
          </h2>
          <div className="mt-8 rounded-3xl overflow-hidden hidden lg:block">
            <img
              src="/images/marypawpins/rottweiler-buttercup-hand.webp"
              alt="A gentle moment between walks"
              className="w-full aspect-[4/5] object-cover"
              data-testid="details-image"
            />
          </div>
        </div>
        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {POINTS.map(({ icon: Icon, title, copy }, i) => (
            <div
              key={title}
              data-testid={`detail-card-${i}`}
              className="bg-white rounded-3xl border border-[#DDD7CB] p-8 hover:border-[#3F4A38]/40 transition-colors"
            >
              <span className="w-11 h-11 rounded-full bg-[#F4ECE9] flex items-center justify-center">
                <Icon className="w-5 h-5 text-[#3F4A38]" />
              </span>
              <h3 className="mt-5 font-serif text-xl font-medium text-[#292A26]">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#575953]">{copy}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
